import React from "react";

export const hasChartData = (data) => {
    if (!data || !Array.isArray(data)) return false;
    return data.some((item) => Number(item.value || item.count || item.amount || 0) > 0);
};

export const EmptyChart = ({ title = "Chưa có dữ liệu biểu đồ" }) => {
    return (
        <div className="flex flex-col items-center justify-center p-8 text-center bg-gray-50 rounded-[16px] w-full min-h-[200px]">
            <div className="bg-white p-4 rounded-full shadow-sm mb-4">
                <svg
                    width="48"
                    height="48"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#94A3B8"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M21.21 15.89A10 10 0 1 1 8 2.83" />
                    <path d="M22 12A10 10 0 0 0 12 2v10z" />
                </svg>
            </div>
            <p className="text-gray-500 font-medium">{title}</p>
        </div>
    );
};

export default EmptyChart;
